import { useFormContext } from 'react-hook-form';
import { FormContainer } from 'components/layout';
import { Box } from '@mui/material';
import { useSyncGlobalApp } from 'hooks';
import { AdAccountSelect } from './TikTokFormComponents';
import { memo, useCallback } from 'react';

const AppAccount = memo(() => {
  const { setValue } = useFormContext();

  const handleChangeApp = useCallback(() => {
    setValue('selectedCampaigns', []);
    setValue('selectedCreatives', []);
    setValue('accountId', '', { shouldValidate: true });
  }, [setValue]);

  const handleChangeAccId = useCallback(() => {
    setValue('selectedCampaigns', []);
    setValue('selectedCreatives', []);
  }, [setValue]);

  useSyncGlobalApp(handleChangeApp);

  return (
    <FormContainer title={'Choose Ad Account'}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'start', width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
          <Box sx={{ display: 'flex', flex: 1 }}>
            <AdAccountSelect handleChange={handleChangeAccId} />
          </Box>
          <Box sx={{ display: 'flex', flex: 1 }}></Box>
        </Box>
      </Box>
    </FormContainer>
  );
});

AppAccount.displayName = 'AppAccount';

export default AppAccount;